import axiosHttp from "./interceptor.service";

// LMT main attendance collection
export const getAttendanceSummary = async (params) => {
    return await axiosHttp.get("/lmt/admin/attendance/summary-report", { params });
};
export const getEmployeeAttendanceDetail = async (userId, params) => {
    return await axiosHttp.get(`/lmt/admin/attendance/employee-detail/${userId}`, { params });
};

// Time Logger attendance (clock-in / clock-out from Time Logger DB)
export const getTLAttendanceSummary = async (params) => {
    return await axiosHttp.get("/lmt/admin/attendance/tl-summary", { params });
};
export const getTLEmployeeDetail = async (userId, params) => {
    return await axiosHttp.get(`/lmt/admin/attendance/tl-detail/${userId}`, { params });
};
